import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["addResourceBundle"];
import { useTranslation } from "@crehana/i18n";
import { AUTH_DIALOG_TRANSLATION_KEY } from "../constants";
import locales from "../i18n";
var useAuthDialogTranslation = function useAuthDialogTranslation() {
  var _useTranslation = useTranslation(AUTH_DIALOG_TRANSLATION_KEY),
    addResourceBundle = _useTranslation.addResourceBundle,
    translationContextValue = _objectWithoutProperties(_useTranslation, _excluded);
  addResourceBundle(locales, {
    injectOnce: true
  });
  return translationContextValue;
};
export default useAuthDialogTranslation;